<div class="mat-typography mat-body mat-app-background main">
  <div class="purl-graph" id="chartID">
    @if (data.length > 0 && columnNames.length > 0) {
      <google-chart #chart  [title]="title" [type]="type" [data]="data" [columns]="columnNames" [options]="options"
        [width]="width" [height]="height" [dynamicResize]="dynamicResize" style="width: 100%;">
      </google-chart>
    }
  </div>

  <div class='filter-section'>
    <div class='header'>
      <h2>{{subheading || 'PURL Progress'}}</h2>
      <div class="material-symbols-outlined icon" (click)="tableView = true" tabindex="0" aria-describedby="listView" role="button">list
      </div>
      <div id="listView" style="display: none">List View</div>
      <div class="material-symbols-outlined icon" (click)="tableView = false" tabindex="0" aria-describedby="gridView" role="button">grid_view
      </div>
      <div id="gridView" style="display: none">Grid View</div>
    </div>

    <div>
      <form [formGroup]="searchForm" class='email-form' (submit)="search(searchForm, false)">
        <div class='filters'>
          <!-- Email-->
          <div class='email'>
            <mat-form-field appearance="outline">
              <mat-label>Email Address</mat-label>
              <input matInput type="textbox" formControlName="emailId">
              @if (searchForm.controls['emailId'].errors?.pattern) {
                <mat-error>Please enter a valid email address
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="content-separator"></div>
          <div class='date-range-section'>
            <mat-form-field appearance="outline" class="search" style="width: 300px">
              <mat-hint align="start" class="hint-color">MM/DD/YYYY – MM/DD/YYYY</mat-hint>
              <mat-label>Creation Date Range</mat-label>
              <mat-date-range-input
                [formGroup]="searchForm"
                [rangePicker]="campaignOnePicker"
                [max]="maxDate">
                <input matStartDate matInput placeholder="From date" formControlName="fromDate">
                <input matEndDate matInput placeholder="To date" formControlName="toDate">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #campaignOnePicker></mat-date-range-picker>
            </mat-form-field>
            <div class="errorMsg">
              @if (searchForm.get('fromDate').errors?.matStartDateInvalid) {
                <mat-error> To date should be greater</mat-error>
              }
              @if (searchForm.get('toDate').errors?.matEndDateInvalid) {
                <mat-error> From date should be lesser</mat-error>
              }
              @if (searchForm.get('fromDate').errors?.matDatepickerMax) {
                <mat-error>From date should be less than or equal to date</mat-error>
              }
              @if (searchForm.get('toDate').errors?.matDatepickerMax) {
                <mat-error>To date should be less than or equal to current date</mat-error>
              }
              @if (searchForm.get('fromDate').errors?.matDatepickerMin) {
                <mat-error>From date should be less than to date</mat-error>
              }
              @if (searchForm.get('fromDate').errors?.matDatepickerParse ||
                searchForm.get('toDate').errors?.matDatepickerParse) {
                <mat-error>
                Enter valid date</mat-error>
              }
              @if ((searchForm.get('fromDate').value !== null && searchForm.get('fromDate').value === null)) {
                <mat-error>To Date is required</mat-error>
              }
            </div>


            <!--<div class='content-separator'>
            <label>From</label>
          </div>
          <div class='date'>
            <mat-form-field appearance="fill">
              <mat-label>MM/DD/YYYY</mat-label>
              <input matInput [matDatepicker]="picker1" formControlName="fromDate">
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
          <div class='content-separator'>
            <label>To</label>
          </div>
          <div class='date'>
            <mat-form-field appearance="fill">
              <mat-label>MM/DD/YYYY</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="toDate">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-error *ngIf="searchForm.controls['fromDate'].value > searchForm.controls['toDate'].value"> To date
            should be greater</mat-error>
          </div>-->
        </div>

        <div class="button-centerer">
          <!-- SUBMIT -->
          <button type="submit" mat-raised-button color="primary" mat-button [disabled]="!searchForm?.valid"
          class="primary-btn">SEARCH</button>
          <button (click)="clearSearch()" type="submit" mat-stroked-button color="primary" class="primary-btn">Clear
          search</button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="paginator-and-filter-container">
  @if (showStatusFilter) {
    <div class="filter-by-status-container">
      @if (showReferralStatusFilter) {
        <div class="visible-filter-view">
          <a (click)="showReferralStatusFilter = !showReferralStatusFilter">
            <span class="material-symbols-outlined">filter_alt</span>Hide More Search Options
          </a>
          <mat-form-field appearance="outline">
            <mat-label>Referral Status Step</mat-label>
            <mat-select [(ngModel)]="selectedStep" aria-placeholder="Referral Status Step"
              (selectionChange)="referralStepEventSelection($event)">
              @for (step of referralStatusSteps; track step) {
                <mat-option [value]="step.value">
                  {{step.label}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (!showReferralStatusFilter) {
        <a (click)="showReferralStatusFilter = !showReferralStatusFilter">
          <span class="material-symbols-outlined">filter_alt</span>Show More Search Options
        </a>
      }
    </div>
  }
  @if(referrals?.length > 6 && referralsPerPage > 6){
    <ng-template [ngTemplateOutlet]="pageNavControls"></ng-template>
  }
</div>

@for (referral of referrals; track referral) {
  <div [ngClass]="{'no-visibility' : tableView.toString() === 'true'?true:false}">
    <app-purl-status-card [referral]=referral [showAppInProgressStep]="showAppInProgressStep"  [showAppReferralType]="showAppReferralType" [isPassiveReferralView]="isPassiveReferralView"></app-purl-status-card>
  </div>
}

<div [ngClass]="{'no-visibility' : tableView.toString() === 'false'?true:false}">

  <table mat-table [dataSource]="referrals" class="mat-elevation-z8">
    <!-- Email Column -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element"> {{element.emailId}} </td>
    </ng-container>

    <!-- Email Sent Column -->
    <ng-container matColumnDef="emailSent">
      <th mat-header-cell *matHeaderCellDef> Email Sent </th>
      <td mat-cell *matCellDef="let element"> {{element.emailSent}} </td>
    </ng-container>

    <!-- Referral ID Column -->
    <ng-container matColumnDef="referralId">
      <th mat-header-cell *matHeaderCellDef> Referral ID </th>
      <td mat-cell *matCellDef="let element"> {{element.referralId}} </td>
    </ng-container>

    <!-- Referral Type Column -->
    <ng-container matColumnDef="referralType">
      <th mat-header-cell *matHeaderCellDef> Referral Type </th>
      <td mat-cell *matCellDef="let element"> {{element.referralType}} </td>
    </ng-container>

    <!-- Link Clicked Column -->
    <ng-container matColumnDef="linkClicked">
      <th mat-header-cell *matHeaderCellDef> Link Clicked </th>
      <td mat-cell *matCellDef="let element">
        @for (clickTime of element.clicked; track $index; let i = $index) {
          <div>
            {{clickTime}}
          </div>
        }
      </td>
    </ng-container>

    <!-- App In Progress Column -->
    <ng-container matColumnDef="appInProgress">
      <th mat-header-cell *matHeaderCellDef> App In Progress </th>
      <td mat-cell *matCellDef="let element">
        @for (app of element.inProgressApps; track app) {
          <div class='body'>
            {{app.applicationId}} {{app.timereference}}
          </div>
        }
      </td>
    </ng-container>

    <!-- App Submitted Column -->
    <ng-container matColumnDef="appSubmitted">
      <th mat-header-cell *matHeaderCellDef> App Submitted </th>
      <td mat-cell *matCellDef="let element">
        @for (app of element.submittedApps; track app) {
          <div class='body'>
            {{app.applicationId}} {{app.timereference}}
          </div>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<ng-template [ngTemplateOutlet]="pageNavControls"></ng-template>
</div>

<ng-template #pageNavControls>
  @if (!hidePaginator) {
    <div class='page-controls'>
      <!-- TODO This should be an actual paginator to keep in line with styling - this done to fix the issue with the label being too big -->
      <p>ITEMS PER PAGE:&nbsp;&nbsp;</p>
      <mat-form-field appearance="outline" class='referrals-per-page margin-right'>
        <!-- <mat-label>ITEMS PER PAGE:</mat-label> -->
        <mat-select aria-label="Items Per Page" (selectionChange)="refreshReferrals()" [(ngModel)]="referralsPerPage">
          @for (number of noOfPlans; track number) {
            <mat-option [value]="number">
              {{number}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <label class='margin-right'>{{firstAppNo}}-{{lastAppNo}} OF {{totalApplications}}</label>
      <button tabindex="0" class="material-symbols-outlined margin-right" aria-label="Previous"
        (click)="prev()"
        [disabled]="currentPage === 1">
        arrow_back_ios
      </button>
      <button tabindex="0" class="material-symbols-outlined" aria-label="Next"
        (click)="next()"
        [disabled]="this.currentPage === this.totalPages || totalApplications === 0">
        arrow_forward_ios
      </button>
    </div>
  }
</ng-template>
